import { pdf } from '@react-pdf/renderer'
import { ReactElement } from 'react'

export const downloadPdf = async (
    pdfDocument: ReactElement,
    filename: string
): Promise<void> => {
    try {
        const blob = await pdf(pdfDocument).toBlob()

        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        URL.revokeObjectURL(url)
    } catch (error) {
        console.error('Failed to generate PDF:', error)
        throw error
    }
}

export const generatePdfBlob = async (
    pdfDocument: ReactElement
): Promise<Blob> => {
    return await pdf(pdfDocument).toBlob()
}